<div class="kz-projectV2">
    <div class="kz-projectV2-container">
        <div class="kz-projectV2-content">
            <div  class="kz-registerV2-form-header">
                <div class="kz-registerV2-form-header-title  mx-5 w-100-c" >
                    <h2 i18n="@@auth.construction-date.firstTitle"><span class="text-green" >a few questions</span> to better support you in your project</h2>    
                </div>
              
          
                <div *ngIf="isInKazaplan$ | async" class="kz-registerV2-from-plan">
                    <kz-jumbotron jumbotronContext="warning">
                        <h3 class="kz-light-title">
                            <kz-icons name="infos" inline="true"></kz-icons>
                            <ng-container i18n="@@auth.kaza.fromKazaplan">Finalize your registration to save your 3D plan</ng-container>
                        </h3>
                    </kz-jumbotron>
                </div>
            </div>
          
            <ng-container>
                <div class="kz-registerV2-form-content " style="flex-direction: column;">
                    <div class="construction-label" > <label kzLabel isRequired="true" i18n="@@auth.construction-date.howSoonDoYouWantToStart"> How soon do you want to start your project ?</label></div>
                    <div class="kz-registerV2-form-dates">
                        <div class="kz-registerV2-form-date" *ngFor="let date of newDates trackBy: dateTrackBy" [class.active]="((dateSelected| date: 'dd/MM/YYYY') === (date?.constructionStartedAt| date:'dd/MM/YYYY')) || (selectedRequalificationLabel === date?.requalificationLabel)" (click)="selectDate(date)" >
                           {{date.label }} 
                        </div>
                        <div class="kz-registerV2-form-date" *ngIf="!constructionDatesAlreadyAnswered" (click)="showStartingDates() "  [class.active]="showExtraStartingDates && !isUnknownDate"   i18n="@@auth.construction-date.justStartDate">
                            I have already begun
                         </div>
                        <div class="kz-registerV2-form-date" (click)="selectUnknownStartDate()"  [class.active]="isUnknownDate === true" i18n="@@auth.construction-date.skip">
                            I don't know my starting date
                         </div>
                         
                    </div>
                    <ng-container *ngIf="showExtraStartingDates" >
                        <div class="started-title">
                            <h2 i18n="@@auth.construction-date.started_title">you started</h2>
                        </div>
                        <div class="kz-registerV2-form-extra-date">
                         <div class="kz-registerV2-form-date" *ngFor="let date of justStartDate trackBy: dateTrackBy" [class.active]="(dateSelected| date: 'dd/MM/YYYY') === (date?.constructionStartedAt| date:'dd/MM/YYYY')" (click)="dateSelected = date?.constructionStartedAt">
                            {{date.label }} 
                         </div>
                         
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="dateSelected || showExtraStartingDates || isUnknownDate">
            <div class="question-new-movers-box px-2">
                <label kzLabel class="my-5" i18n="@@auth.construnction-date.projectBuyRealEstate">Your project relates to a real estate purchase ?</label>
                <div class="question-new-movers w-xl-70">
                    <div class="kz-registerV2-form-date mx-2" (click)="isRelatifProject= true" [class.active]="isRelatifProject === true" i18n="@@auth.construnction-date.yes">
                        Yes 
                     </div>
                     <div class="kz-registerV2-form-date" (click)="isRelatifProject= false;selectedRelatifDate=null" [class.active]="isRelatifProject === false" i18n="@@auth.construnction-date.no">
                        No
                     </div>
                </div>
                
            </div>
            <div class="question-new-movers-box px-2 my-5" *ngIf="isRelatifProject === true">
               <label kzLabel class="my-5" i18n="@@auth.construnction-date.projectBuyViewRealEstate">Your project relates to a real estate purchase :</label>
                <div class="question-new-movers ">
                    <div class="kz-registerV2-form-date mx-2" *ngFor="let item of relatifProjectDate trackBy: dateTrackBy" [class.active]="item?.value === selectedRelatifDate"  (click)="selectedRelatifDate=item?.value"> 
                        {{item.label}} 
                     </div>

                </div>
                
            </div>
           

            <div class="question-new-movers-box px-2">
                <label kzLabel class="my-5" i18n="@@auth.construnction-date.projectSellRealEstate">Your project relates to the sale of real estate ?</label>
                <div class="question-new-movers w-xl-70">
                    <div class="kz-registerV2-form-date mx-2" (click)="isSellRelatifProject = true" [class.active]="isSellRelatifProject === true" i18n="@@auth.construnction-date.yes">
                        Yes 
                     </div>
                     <div class="kz-registerV2-form-date" (click)="isSellRelatifProject = false; selectedIsSellRelatifDate=null;" [class.active]="isSellRelatifProject === false " i18n="@@auth.construnction-date.no">
                        No
                     </div>
                </div>
            </div>
                <div class="question-new-movers-box px-2 my-5" *ngIf="isSellRelatifProject === true">
                    <label kzLabel class="my-5"i18n="@@auth.construnction-date.projectSellViewRealEstate">Your project relates to the sale of real estate :</label>
                    <div class="question-new-movers" >
                        <div class="kz-registerV2-form-date mx-2" *ngFor="let item of relatifProjectDate" (click)="selectedIsSellRelatifDate=item?.value" [class.active]="item?.value === selectedIsSellRelatifDate" > 
                            {{item.label}}  
                         </div>
                    </div>
                </div>
            </ng-container>
            <div class="kz-field-buttons" >
              <button type="submit" kzButton buttonStyle="flat" 
                [disabled]="(submitted || !dateSelected) && !isUnknownDate"
                [buttonState]="submitted ? 'loading' : 'default'" data-cy="submit" (click)="save()">
                <span i18n="@@auth.button.next">Next</span>
              </button>
              
            </div>
          
        </div>
    </div>
</div>